//central of variables and methods
import { createStore } from "vuex";
import axios from "axios";
import Constants from "./constants.ts";
const store = createStore({
  state: {
    agent_user: [],
    token: "",
    agent_data: [],
    errors: [],
    agent_list: [],
  },
  mutations: {
    AGENT_LIST(state, data) {
      state.agent_list = data;
    },
    SAVE_LOGGED_USER(state, data) {
      state.agent_user = data;
    },
    SAVE_TKN(state, token) {
      state.token = token;
    },
    SAVE_USER(state, data) {
      state.agent_data = data;
    },
    SET_ERRORS(state, errors) {
      state.errors = errors;
    },
  },
  actions: {
    setAgentTkn({ commit }) {
      let agenToken = JSON.parse(localStorage.getItem("agent_data"));
      commit("SAVE_TKN", agenToken);
    },
    setRegData({ commit }) {
      let attData = JSON.parse(localStorage.getItem("registered_user"));
      commit("SAVE_USER", attData);
    },
    setSelectedAgent({ commit }) {
      let agent = JSON.parse(localStorage.getItem("selected_agent"));
      commit("SAVE_LOGGED_USER", agent);
    },
    resetPassword(context, payload) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "reset_password.php",
        headers: {
          "Content-Type": "text/plain",
        },
        data: JSON.stringify(payload),
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then((result) => {
            document.getElementById("loader").classList.add("hidden");
            if (result.data.status == "Failed") {
              reject(result.data.message);
            } else {
              resolve(result);
            }
          })
          .catch((error) => {
            console.log(error);
            reject(error.response.data.errors);
          });
      });
    },
    forgotPassword(context, payload) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "get_forgot_password_otp.php",
        headers: {
          "Content-Type": "text/plain",
        },
        data: JSON.stringify(payload),
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then((result) => {
            document.getElementById("loader").classList.add("hidden");
            if (result.data.status == "Failed") {
              reject(result.data.message);
            } else {
              resolve(result);
            }
          })
          .catch((error) => {
            console.log(error);
            reject(error.response.data.errors);
          });
      });
    },
    generateQTURL() {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "get",
        url: Constants.API_BASE + "get_quating_url.php",
        headers: {
          "Content-Type": "text/plain",
          "Authorization": this.state.token
        },
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then((result) => {
            document.getElementById("loader").classList.add("hidden");
            if (result.data.status == "Failed") {
              reject(result.data.message);
            } else {
              resolve(result);
            }
          })
          .catch((error) => {
            console.log(error);
            reject(error.response.data.errors);
          });
      });
    },
    loginAgent(context, payload) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "login.php",
        headers: {
          "Content-Type": "text/plain",
        },
        data: JSON.stringify(payload),
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then((result) => {
            document.getElementById("loader").classList.add("hidden");
            if (result.data.status == "Failed") {
              reject(result.data.message);
            } else {
              resolve(result);
            }
          })
          .catch((error) => {
            console.log(error);
            reject(error.response.data.errors);
          });
      });
    },
    setupAgent({ commit }, payload) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "check_agent.php",
        headers: {
          "Content-Type": "text/plain",
          "Authorization":Constants.ACCESS_KEY
        },
        data: JSON.stringify(payload),
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then((result) => {
            document.getElementById("loader").classList.add("hidden");
            if (result.data.status == "Failed" ||
            result.data.status == "unAuthorized") {
              reject(result.data.message);
            } else {
              commit("SAVE_USER", result.data);
              resolve(result);
            }
          })
          .catch((error) => {
            console.log(error);
            reject(error.response.data.errors);
          });
      });
    },
    registerAgent(context, payload) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "register.php",
        headers: {
          "Content-Type": "text/plain",
        },
        data: JSON.stringify(payload),
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then((result) => {
            document.getElementById("loader").classList.add("hidden");
            if (result.data.status == "Failed") {
              reject(result.data.message);
            } else {
              resolve(result);
            }
          })
          .catch((error) => {
            console.log(error);
            reject(error.response.data.errors);
          });
      });
    },
    verifyOTP(context, payload) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "verify_otp.php",
        headers: {
          "Content-Type": "text/plain",
        },
        data: JSON.stringify(payload),
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then((result) => {
            document.getElementById("loader").classList.add("hidden");
            if (result.data.status == "Failed") {
              reject(result.data.message);
            } else {
              resolve(result);
            }
          })
          .catch((error) => {
            console.log(error);
            reject(error.response.data.errors);
          });
      });
    },
    resendOTP(context, payload) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "resend_otp.php",
        headers: {
          "Content-Type": "text/plain",
        },
        data: JSON.stringify(payload),
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then((result) => {
            document.getElementById("loader").classList.add("hidden");
            if (result.data.status == "Failed") {
              reject(result.data.message);
            } else {
              resolve(result);
            }
          })
          .catch((error) => {
            console.log(error);
            reject(error.response.data.errors);
          });
      });
    },
    getAgentData({ commit }, payload) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "get_agent_data.php",
        headers: {
          "Content-Type": "text/plain",
          "Authorization": this.state.token,
        },
        data: JSON.stringify(payload),
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then((result) => {
            document.getElementById("loader").classList.add("hidden");
            if (
              result.data.status == "Failed" ||
              result.data.status == "unAuthorized"
            ) {
              reject(result.data);
            } else {
              commit("AGENT_LIST", result.data.data);
              resolve(result.data);
            }
          })
          .catch((error) => {
            console.log(error);
            reject(error.response.data.errors);
          });
      });
    },
    addAgent(context, payload) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "add_child_agent.php",
        headers: {
          "Content-Type": "text/plain",
          "Authorization": this.state.token,
        },
        data: JSON.stringify(payload),
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then((result) => {
            document.getElementById("loader").classList.add("hidden");
            if (
              result.data.status == "Failed" ||
              result.data.status == "unAuthorized"
            ) {
              reject(result.data.message);
            } else {
              resolve(result.data);
            }
          })
          .catch((error) => {
            console.log(error);
            reject(error.response.data.errors);
          });
      });
    },
    logout({ commit }) {
      localStorage.removeItem("agent_data");
      localStorage.removeItem("registered_user");
      localStorage.removeItem("selected_agent");      
      commit("SAVE_LOGGED_USER", []);
      commit("SAVE_TKN", "");
      commit("SAVE_USER", []);
      commit("AGENT_LIST", []);
    },
  },
  modules: {},
});
export default store;
